import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "group p-4 my-4 bg-amber-50 rounded-lg shadow-md ring-1 ring-amber-200 transition-all duration-200"
}
const _hoisted_2 = { class: "flex flex-col gap-3" }
const _hoisted_3 = { class: "text-lg font-semibold text-amber-900" }
const _hoisted_4 = { class: "text-amber-800" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-wrap items-center gap-2"
}
const _hoisted_6 = { class: "text-amber-800" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}

import { computed } from 'vue';
import type { OperationInfo } from '@/types/v2/task/animal-transfer/operation.types';
import type { FishTransfer, GroupTag } from '@/types/v2';

interface Props {
    transferInfo?: OperationInfo;
    actualTransfers: FishTransfer[];
    newTags: GroupTag[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OperationCard',
  props: {
    transferInfo: { default: undefined },
    actualTransfers: { default: () => [] },
    newTags: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

const headline = computed(() => props.transferInfo?.headline ?? '');
const mainDescription = computed(() => props.transferInfo?.description?.main ?? '');
const additionalDescription = computed(() => props.transferInfo?.description?.additional);
const showTags = computed(() => !!additionalDescription.value && props.actualTransfers.length > 0);

return (_ctx: any,_cache: any) => {
  return (_ctx.transferInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, " Required Operation: " + _toDisplayString(headline.value), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(mainDescription.value), 1),
          (additionalDescription.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(additionalDescription.value), 1),
                (showTags.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newTags, (tag) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: tag.key,
                          class: "px-2.5 py-1 text-xs font-medium rounded-md shadow-sm transition-colors duration-200",
                          style: _normalizeStyle({
                            backgroundColor: tag.backgroundColor,
                            color: tag.textColor
                        })
                        }, _toDisplayString(tag.title), 5))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})